import { useParams } from "react-router-dom";
import Table, { Column } from "../../../Components/Tables/Table";
import { useEffect, useState } from "react";
import { CardexInquiryPayload, InventoryCardexInquiry, InventoryDetailsTabProps } from "./model/inventoryOverview.model";
import { ApiResponse } from "../../../model/common/apiResponse";
import Loader from "../../../Components/GlobalLoader/Loader";
import { getInventoryCardexInquiry } from "./service/inventoryOverview.service";
import { formatDate } from "../../../Utility/Utility";
import { usePagination } from "../../../hooks/usePagination";

export const CardexInquiry:React.FC<InventoryDetailsTabProps> = ({
    warehouseId
}) => {
  const { id } = useParams();
  const [cardexData, setCardexData] = useState<ApiResponse<any> | null>(null);
  const [loading, setLoading] = useState(true);
  const { currentPage, handlePageChange, perPage } = usePagination();
  let payload = { ...CardexInquiryPayload }

  const columns: Column[] = [
    {
      name: "Inv Status",
      selector: (row: InventoryCardexInquiry) => row?.inventory_status ? row.inventory_status : '-',
    },
    {
      name: "Posted",
      selector: (row: InventoryCardexInquiry) => row?.created_at ? formatDate(row?.created_at) : '-',
    },
    // {
    //   name: "Ref No.",
    //   selector: (row: { refNo: string }) => row.refNo.replace(/\/10/g, ""),
    // },
    {
      name: "Type",
      selector: (row: InventoryCardexInquiry) => row?.description ? row?.description : '-',
    },
    {
      name: "Prior Qty",
      selector: (row: InventoryCardexInquiry) => row?.prior_qty ? row?.prior_qty : 0,
    },
    {
      name: "Qty In/Out",
      selector: (row: InventoryCardexInquiry) => row?.event_qty ? row?.event_qty : 0,
    },
    {
      name: "Balance",
      selector: (row: InventoryCardexInquiry) => row?.new_qty ? row?.new_qty : 0,
    },
    // {
    //   name: <div className="text-start">Cust/Supp</div>, // Apply text-center to the header
    //   selector: (row: { invStatus: string }) => (
    //     <div className="text-start">
    //       {row.invStatus}
    //     </div>
    //   ),
    // },
  ];

  useEffect(() => {
    if (id) {
      setLoading(true);
      payload.conditions = [
        ["inventory_user_event.warehouse_id", "=", warehouseId],
        ["inventory_user_event.item_id", "=", id]
      ];
      payload.order = [
        {
          "column": "inventory_user_event.created_at",
          "dir": "desc"
        }
      ];
      payload.limit = perPage;
      payload.page = currentPage;
      getInventoryCardexInquiry(payload).then((response) => {
        setCardexData(response ?? null);
      }).finally(() => {
        setLoading(false);
      });
    }
  }, [id, currentPage])

  return !loading ? (
    <>
      {/* <div className="mb-2 mt-1 bg-white rounded">
        <div className="p-4 col-4">
          <label className="d-block text-grey mb-1 fw-medium">Inv Status</label>
          <div className="w-100 p-2 d-flex justify-content-between rounded border border-2">
            <label className="text-grey">Search</label>
            {GetSvgIcon.GlobalSearchIcon}
          </div>
        </div>
      </div> */}
      {/* <div className="row mx-0 px-0  d-flex">
        <div className="mb-2 mt-1 bg-white rounded col-3 me-2">
          <div className="d-flex p-4 flex-wrap gap-4 mt-5">
            <div className="row d-flex col-12 justify-content-between">
              <div className="col-6 fw-bold">This Location</div>
              <div className="col-6 d-flex justify-content-end">800</div>
            </div>
            <div className="row d-flex col-12 justify-content-between">
              <div className="col-6 fw-bold">All Location</div>
              <div className="col-6 d-flex justify-content-end">800</div>
            </div>
          </div>
        </div>
        <div className="mb-2 mt-1 bg-white rounded col">
          <div className="p-4 d-flex flex-wrap">
            <div className="wrapper d-flex col-12">
              <div className="col-3 d-flex justify-content-center fw-bold px-0">
                Qty O/H
              </div>
              <div className="col-3 d-flex justify-content-center fw-bold px-0">
                ASN Qty
              </div>
              <div className="col-3 d-flex justify-content-center fw-bold px-0">
                Order Qty
              </div>
              <div className="col-3 d-flex justify-content-center fw-bold px-0">
                Qty Avail
              </div>
            </div>
            <div className="wrapper d-flex col-12 py-3 list-strip-bg mt-2 rounded">
              <div className="col-3 d-flex justify-content-center  px-0">-</div>
              <div className="col-3 d-flex justify-content-center  px-0">
                700
              </div>
              <div className="col-3 d-flex justify-content-center  px-0">
                300
              </div>
              <div className="col-3 d-flex justify-content-center  px-0">-</div>
            </div>
            <div className="wrapper d-flex col-12 py-3 mt-2 rounded">
              <div className="col-3 d-flex justify-content-center  px-0">
                700
              </div>
              <div className="col-3 d-flex justify-content-center  px-0">
                700
              </div>
              <div className="col-3 d-flex justify-content-center  px-0">
                700
              </div>
              <div className="col-3 d-flex justify-content-center  px-0">-</div>
            </div>
          </div>
        </div>
      </div> */}
      <div className="mb-2 mt-1 bg-white rounded p-3">
          <Table
            columns={columns}
            data={cardexData?.data?.results || []}
            isStripped={true}
            CheckboxStatus={false}
            pagination={{
              recordsPerPage: perPage,
              totalRecords: cardexData?.data?.recordsTotal,
              currentPage: currentPage,
              onCurrentPageChange: handlePageChange,
            }}
          />
      </div>
    </>
  ) : <Loader />;
}
